import { useDispatch } from "react-redux"

import { FormPageProps } from "../.."
import { DropdownObj } from "../../../../pages/Common/commonTypes"
import CheckboxList from "../../../Checkbox/CheckboxList"
import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import RadioGroup from "../../../RadioGroup/RadioGroup"
import { DEAL_TYPE_OPTIONS } from "../../config/projectFormConstants"
import { setDealSowForm } from "../../RaiseTicketFormSlice"
import useRaiseTicketDealDetails from "./useRaiseTicketDealDetails"

import error_mark from "../../../../assets/images/error_mark.svg"

const DealDetailsBeta = ({ handleNextStep, handleCloseForm, module }: FormPageProps) => {
    const dispatch = useDispatch()

    const { states, functions } = useRaiseTicketDealDetails({ handleNextStep, handleCloseForm, module })

    return (
        <>
            <div className="deal_sow">
                <div className="section">
                    <div className="section_header">Deal Templates</div>
                    <div className="width-40p">
                        <MultiSelectDropdown
                            fontsize="12px"
                            title="Select A Template"
                            options={states.dealTemplateOptions}
                            id="sow_template"
                            onChange={() => {}}
                            selectedOptions={[states.formik.values.deal_template]}
                            selectionType={"single"}
                            onSelect={(value: DropdownObj) => {
                                states.formik.setFieldValue("deal_template", value)
                                functions.handleDealTemplateChange(value)
                            }}
                            height="44px"
                            error={Boolean((states.formik.errors.deal_template as any)?.title)}
                            showError={true}
                            disabled={states.isDealDetailsDisabled}
                        />
                    </div>
                    {states.formik.errors.deal_template &&
                        !!states.formik.values.deal_type.title &&
                        states.formik.values.deal_scope_of_work.length > 0 && (
                            <div className="error_message">
                                <img src={error_mark} alt="" className="pr-4" />
                                <span>No project case exists against selected Deal type and Scope of Work</span>
                            </div>
                        )}
                </div>
                <div className="section">
                    <div className="section_header">
                        Specify Deal Type?* {states.formik.errors.deal_type && <img src={error_mark} alt="" />}
                    </div>
                    <div>
                        <RadioGroup
                            options={DEAL_TYPE_OPTIONS}
                            name="deal_type"
                            onSelect={(value: DropdownObj) => {
                               functions.handleDealTypeChange(value)
                                // states.formik.setFieldValue("deal_type", value)
                                // dispatch(
                                //     setDealSowForm({
                                //         value: value,
                                //         key: "deal_type",
                                //     })
                                // )
                                // dealDetailsSetter("deal_type", value);
                            }}
                            value={states.deal_sow_form.deal_type}
                            //   disabled={freezeField("deal_type")}
                        />
                    </div>
                </div>
                <div className="section">
                    <div className="section_header">
                        Deal's Scope of Work?*{" "}
                        {states.formik.errors.deal_scope_of_work && <img src={error_mark} alt="" />}
                    </div>
                    <div>
                        <CheckboxList
                            name="deal_scope_of_work"
                            options={states.dealScopeOfWorkOptions}
                            onChange={value => {
                                states.formik.setFieldValue("deal_scope_of_work", value)
                                functions.handleCheckboxChange(value)
                            }}
                            initialValues={states.formik.values.deal_scope_of_work}
                            disabled={states.isDealDetailsDisabled}
                            highlightChecked={
                                states.formik.values.deal_scope_of_work[0]?.title === "Solo Logistics" ||
                                states.formik.values.deal_scope_of_work[0]?.title === "Solo Survey"
                                    ? true
                                    : false
                            }
                        />
                    </div>
                </div>
            </div>

            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button
                    className="raise-ticket-form__footer-button next-btn"
                    onClick={() => states.formik.handleSubmit()}>
                    Next
                </button>
            </footer>
        </>
    )
}

export default DealDetailsBeta
